// Every import in this module is static, so evaluation order is the import order: a module that imports this one
// first gets every polyfill before any later import evaluates. A Vite client build keeps that guarantee across code
// splitting only when this module and its dependencies sit in the pinned `polyfills` chunk, because Rolldown evaluates
// every chunk the entry imports before the entry chunk's own module bodies. `startViteConfig` in
// `@district-core/tanstack-start-utils` provides the pin.
//
// Each core-js module feature-detects and does nothing on an engine that already has the feature.
import 'core-js/proposals/iterator-helpers.js'
import 'core-js/proposals/change-array-by-copy.js'
import 'core-js/proposals/set-methods-v2.js'
import 'core-js/proposals/map-upsert-v4.js'
import 'core-js/proposals/array-buffer-base64.js'
// Safari <18 / Chrome <126. core-js installs the static method over the native URL rather than replacing the
// constructor, so modern engines that already have it pay nothing.
import 'core-js/modules/web.url.parse.js'
// Chrome <119 / Safari <17.4 / Firefox <121. Our promise/avoid-new lint rule steers all code onto this.
import 'core-js/modules/es.promise.with-resolvers.js'
import '#@/installTemporal.ts'

// oxlint-disable-next-line import/no-default-export -- force bundling a .d.ts
export default {} as const
